import React from "react";
import MusicShare from "./MusicShare";
import { AuthProvider } from "./context/AuthProvider";

const App = () => <AuthProvider><MusicShare/></AuthProvider>

export default App;
